/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useState } from "react";
import { Box, Button, Heading, SimpleGrid, useToast } from "@chakra-ui/react";
import { Raider } from "../../../types/raider";
import {
	ownedMounts,
	equippedMount,
	isRaiderMounted,
	getMountOwnerAddress,
	dismount,
} from "../../../util/web3/interactMounts";
import Mount from "./Mount";
import Dismount from "./Dismount";
import { getAccount } from "../../../util/web3/interactBank";
import { Mount as MountInfo } from "../../../types/mount";

interface StatProps {
	raider: Raider;
	all_my_raiders: Raider[];
}

export default function MountPanel(props: StatProps) {
	const { raider } = props;
	const [mounts, setMounts] = useState<MountInfo[]>(); //Just a simple re-use here for the time being.
	const [equipped, setEquipped] = useState<MountInfo | null>();
	const [isMounted, setIsMounted] = useState<boolean>();
	const [showForceDismount, setShowForceDismount] = useState<boolean>();

	const toast = useToast();

	useEffect(() => {
		const fetchData = async () => {
			const mountData = await ownedMounts();
			if (mountData) {
				setMounts(mountData);
			}
			
			const tempIs = await isRaiderMounted(parseInt(raider.id));
			setIsMounted(tempIs);

			if (tempIs) {
				const tempEquipped = await equippedMount(parseInt(raider.id));
				if (tempEquipped) {
					setEquipped(tempEquipped.data);
					const mountOwner = await getMountOwnerAddress(tempEquipped.data.id);
					const myAddress = await getAccount();
					setShowForceDismount(mountOwner != myAddress)
				}
			}
		};

		fetchData();
	}, [raider.id]);

	return (
		<Box>
			{showForceDismount && 
				<div>
					<p>This raider&apos;s mount is currently owned by someone else.</p>
					<Button onClick={() => dismount(parseInt(raider.id), toast)}>Force dismount</Button>
				</div>
			}

			{isMounted && equipped ? (
				<Box>
					<Heading mb="10px">Equipped</Heading>
					<Box background="#4a556878" borderRadius="md" px={4} py={4} mb="15px">
						<SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing="4">
							<Dismount mount={equipped} raider={raider} />
						</SimpleGrid>
					</Box>
				</Box>
			) : (
				""
			)}

			<Heading mb="10px">Available</Heading>
			<Box background="#4a556878" borderRadius="md" px={4} py={4}>
				<SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing="4">
					{mounts
						? mounts.map(mount => (
								<Mount key={mount.id} mount={mount} raider={raider} />
						  ))
						: ""}
				</SimpleGrid>
			</Box>
		</Box>
	);
}
